import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_api_live , Base_url_imggg } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";
import { FaTrash, FaTimes, FaUpload, FaPlus } from "react-icons/fa";

const initialData = {
  pro: "Sameday", 
  proThree: "",
  profive: "", 
  prouser : "",
  prohead : "" ,
  pronoti : "" ,
  proremove : ""
};

const initialDataedu = {
  pro: "Sameday", 
  proThree: "",
  profive: "", 
  prouser : "",
  prohead : "" ,
  pronoti : "",
  proremove : ""
};

let User_month_offer = () => {
  let [data, setData] = useState();
  const [ggs, setGgs] = useState([]);

  let [datas, setDatas] = useState();

  let [one, setOne] = useState();
  let [two, setTwo] = useState();
  let [three, setThree] = useState(true);

  let [five, setFive] = useState();
  let [six, setSix] = useState();
  let [seven, setSeven] = useState(true);

  let [eight, setEight] = useState();
  let [nine, setNine] = useState();
  let [ten, setTen] = useState(true);


  let [four, setFour] = useState();

  let [utilityflow, setUtilityflow] = useState(true);

  let [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  let [text, setText] = useState("");

  let [eduval, setEduval] = useState()
  let [utival, setUti] = useState()
  let [finedata, setFinedata] = useState()

  const [formBlocks, setFormBlocks] = useState([initialData]);


  let [ startdate , setStartdate ] = useState()
  let [ enddate , setEnddate ] = useState()

  useEffect(()=>{

    Start()

  },[])


  let Start = async () =>{
    try {
      let token = await localStorage.getItem("token");

      let pp = { token };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/rentlatthree",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          setData(Jsson)
 
          console.log( JSON.stringify( Jsson ), "Jsson ddddddddddddddddddddddddddddddddddddddddddddddddddddddddd");

        })
        .catch((ee) => { });
    } catch (err) { }
  } 

   const handleImageUpload = async (event , tts) => {

    console.log("Failed to upload image to S3");
    const files = Array.from(event.target.files);
    setGgs([]);

    if (files.length > 0) {
      for (let file of files) {
        try {
          const formData = new FormData();
          formData.append('file', file);

          const uploadResponse = await axios({
            method: "post",
            url: 'https://web.xopay.in/bbps/api/transactionstatus/fileUpload',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          if (uploadResponse.data.status && uploadResponse.data.url) {
            let s3Url = uploadResponse.data.url;
            console.log(s3Url, "Uploaded to S3");

            // If you want to store multiple image URLs, consider using an array
            // setGgs(prev => [...prev, s3Url]);


            uploadbanner ( tts , s3Url ) 


          } else {
            console.error("Failed to upload image to S3");
          }
        } catch (error) {
          console.error("Error uploading image to S3:", error);
        }
      }




    }
  };

  let uploadbanner = async ( tts , s3Url ) => {

    console.log(ggs, 'gggggggggggggggggggggg')
 
 
      let pp = { id : tts.id ,  img : s3Url  } 

       
      let apicall = await axios({
        method: 'post',
        url: Base_url + '/admin2/saveuser',
        data: {pp }
      })
      .then((dat) => {
        Start()
        console.log(dat.data, 'Jsson') 

      })
      .catch((ee) => {
        console.log(ee, 'eeeeeeeeeeee')
      })
  }

  let Submits = async ( ) =>{
    console.log('Jsson' , 'Jsson fff')
    try {
      let token = await localStorage.getItem("token");

      let pp = { token , start : startdate , end : enddate  };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/rentlatthree_sel",
        data: pp,
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson , 'Jsson fff')
          setDatas(Jsson)
 
          console.log( JSON.stringify( Jsson ), "Jsson ddddddddddddddddddddddddddddddddddddddddddddddddddddddddd");

        })
        .catch((ee) => { });
    } catch (err) { }
  }
 
 

  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        > 
        <p className="mt-2" style={{ fontWeight: "bold", fontSize: "20px" }} >User Month offer </p> 

        <p className="mt-2" style={{  fontSize: "24px" }}>Top 3 User</p>

        <div style={{ marginTop : 20 }} >
          <div className="row">
            {
              data?.data?.map((tt, index) => {

                
                return (
                  <div className="col-4" style={{ border: "1px solid #ddd", padding: "10px" }}>
                    <p style={{ fontSize: 20, fontWeight: "bold" }}>{index+1}</p>
                    <div className="d-flex justify-content-between" >
                      <p style={{ fontSize: 20, fontWeight: "bold" }}>{tt?.amount}</p>
 
                      <label className="btn btn-outline-secondary mt-4">
                        <FaUpload />
                        <input
                          type="file"
                          accept="image/*" 
                          onChange={(e)=>{ handleImageUpload(e , tt) }}
                          style={{ display: "none" }}
                        />
                      </label>

                        <img
                              src={Base_url_imggg + tt?.userfine?.image}
                              // alt={finedata[key].name}
                              className="img-fluid rounded"
                              style={{ width : 50 , height : 50 }}
                            />



                      {/* <button className="mt-5" onClick={()=>{ uploadbanner()}}> Image Submit </button> */}



                    </div>
                    {/* <p style={{ fontSize: 20, fontWeight: "bold" }}>{tt?.amount}</p> */}
                    <div className="d-flex justify-content-between" >
                      <p style={{ fontSize: 20, fontWeight: "bold" }}>{tt?.userfine?.name}</p>
                      <button onClick={() => {
                        navigate("/useralldetail", { state : tt?.userfine })
                      }}  >View</button>
                    </div>

                    {
                      tt?.userfine?.fraud === true ?  <div style={{ color : 'red' }} > Fraud not show in live </div > : ""
                    }

                    
                    
                  </div>
                )
              })
            }
          </div>

            
        </div>

        <div className="row">
           <div className="col-2">
              <p>select start date</p>
              <input onChange={(e)=>{ setStartdate(e.target.value) }} type="date" />
            </div>

            
 
            <div className="col-2">
              <p>select end date</p>
              <input type="date" onChange={(e)=>{ setEnddate(e.target.value) }} />
            </div>

            <div className="col-2">
               
              <button onClick={()=>{ Submits() }} >Sumbit</button>
            </div> 
        </div>

        <div style={{ marginTop : 20 }} >
          <div className="row">
            {
              datas?.data?.map((tt, index) => {

                
                return (
                  <div className="col-4" style={{ border: "1px solid #ddd", padding: "10px" }}>
                    <p style={{ fontSize: 20, fontWeight: "bold" }}>{index+1}</p>
                    <div className="d-flex justify-content-between" >
                      <p style={{ fontSize: 20, fontWeight: "bold" }}>{tt?.amount}</p>
 
                      <label className="btn btn-outline-secondary mt-4">
                        <FaUpload />
                        <input
                          type="file"
                          accept="image/*" 
                          onChange={(e)=>{ handleImageUpload(e , tt) }}
                          style={{ display: "none" }}
                        />
                      </label>

                        <img
                              src={Base_url_imggg + tt?.userfine?.image}
                              // alt={finedata[key].name}
                              className="img-fluid rounded"
                              style={{ width : 50 , height : 50 }}
                            />



                      {/* <button className="mt-5" onClick={()=>{ uploadbanner()}}> Image Submit </button> */}



                    </div>
                    {/* <p style={{ fontSize: 20, fontWeight: "bold" }}>{tt?.amount}</p> */}
                    <div className="d-flex justify-content-between" >
                      <p style={{ fontSize: 20, fontWeight: "bold" }}>{tt?.userfine?.name}</p>
                      <button onClick={() => {
                        navigate("/useralldetail", { state : tt?.userfine })
                      }}  >View</button>
                    </div>

                    {
                      tt?.userfine?.fraud === true ?  <div style={{ color : 'red' }} > Fraud not show in live </div > : ""
                    }

                    
                    
                  </div>
                )
              })
            }
          </div>

            
        </div>


        </div>
      </div>
    </div>
  );
};

export default User_month_offer;
